var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06099 16.9766H3V5.8C3 5.32261 3.18964 4.86477 3.52721 4.52721C3.86477 4.18964 4.32261 4 4.8 4H13.566C14.0434 4 14.5012 4.18964 14.8388 4.52721C15.1764 4.86477 15.366 5.32261 15.366 5.8L15.366 15.646V9.86156H19.2C19.6774 9.86156 20.1352 10.0512 20.4728 10.3888C20.8104 10.7263 21 11.1842 21 11.6616V16.9496H17.5286M13.5121 16.9767H8.76904M7.13108 10.637L11.235 10.6368M11.235 10.6368L9.27308 12.7068M11.235 10.6368L9.27308 8.57584M8.76904 17.5746C8.76904 18.5985 7.93903 19.4286 6.91509 19.4286C5.89116 19.4286 5.06104 18.5985 5.06104 17.5746C5.06104 16.5507 5.89116 15.7206 6.91509 15.7206C7.93903 15.7206 8.76904 16.5507 8.76904 17.5746ZM17.6366 17.5746C17.6366 18.5985 16.8065 19.4286 15.7825 19.4286C14.7586 19.4286 13.9286 18.5985 13.9286 17.5746C13.9286 16.5507 14.7586 15.7206 15.7825 15.7206C16.8065 15.7206 17.6366 16.5507 17.6366 17.5746Z",
    stroke: "#0098A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "dc984e4cde1398cc631817e72177dfab.svg";
export { ForwardRef as ReactComponent };